import createReactComponent from '../createReactComponent';
export default createReactComponent('circle-half-2', 'IconCircleHalf2', [
  ['path', { d: 'M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0', key: 'svg-0' }],
  ['path', { d: 'M12 3v18', key: 'svg-1' }],
  ['path', { d: 'M12 14l7 -7', key: 'svg-2' }],
  ['path', { d: 'M12 19l8.5 -8.5', key: 'svg-3' }],
  ['path', { d: 'M12 9l4.5 -4.5', key: 'svg-4' }],
]);
